export const ERR_CANCELED = 'ERR_CANCELED'
export const DATA_RESPONSE_DONE = '[DONE]'
